export default "__VITE_ASSET__BXVPSy1I__"